import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../../pwa/store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../../pwa/store/abTest.js'), 'abTest.js')
  resolveStoreModules(require('../../pwa/store/abTests.js'), 'abTests.js')
  resolveStoreModules(require('../../pwa/store/anchor.js'), 'anchor.js')
  resolveStoreModules(require('../../pwa/store/asyncCofirmation.js'), 'asyncCofirmation.js')
  resolveStoreModules(require('../../pwa/store/booking.js'), 'booking.js')
  resolveStoreModules(require('../../pwa/store/bookingConfigure.js'), 'bookingConfigure.js')
  resolveStoreModules(require('../../pwa/store/common.js'), 'common.js')
  resolveStoreModules(require('../../pwa/store/cookie.js'), 'cookie.js')
  resolveStoreModules(require('../../pwa/store/faq.js'), 'faq.js')
  resolveStoreModules(require('../../pwa/store/featureFlag.js'), 'featureFlag.js')
  resolveStoreModules(require('../../pwa/store/filtersAbTest.js'), 'filtersAbTest.js')
  resolveStoreModules(require('../../pwa/store/footer.js'), 'footer.js')
  resolveStoreModules(require('../../pwa/store/ga4.js'), 'ga4.js')
  resolveStoreModules(require('../../pwa/store/gdpr.js'), 'gdpr.js')
  resolveStoreModules(require('../../pwa/store/header.js'), 'header.js')
  resolveStoreModules(require('../../pwa/store/insider.js'), 'insider.js')
  resolveStoreModules(require('../../pwa/store/locations.js'), 'locations.js')
  resolveStoreModules(require('../../pwa/store/payment.js'), 'payment.js')
  resolveStoreModules(require('../../pwa/store/randomicIdList.js'), 'randomicIdList.js')
  resolveStoreModules(require('../../pwa/store/reloadoffline.js'), 'reloadoffline.js')
  resolveStoreModules(require('../../pwa/store/rentalCenter.js'), 'rentalCenter.js')
  resolveStoreModules(require('../../pwa/store/rentals.js'), 'rentals.js')
  resolveStoreModules(require('../../pwa/store/routes.js'), 'routes.js')
  resolveStoreModules(require('../../pwa/store/search.js'), 'search.js')
  resolveStoreModules(require('../../pwa/store/searchFilters.js'), 'searchFilters.js')
  resolveStoreModules(require('../../pwa/store/searchNew.js'), 'searchNew.js')
  resolveStoreModules(require('../../pwa/store/stateSelected.js'), 'stateSelected.js')
  resolveStoreModules(require('../../pwa/store/stepAbTest.js'), 'stepAbTest.js')
  resolveStoreModules(require('../../pwa/store/user.js'), 'user.js')
  resolveStoreModules(require('../../pwa/store/vwoStore.js'), 'vwoStore.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
